import React from 'react';
import { Terminal, Sparkles, Link as LinkIcon, Wrench } from 'lucide-react';

const VaultSwitcher = ({ currentVault, setCurrentVault }) => {
  return (
    <div className="flex items-center gap-1.5 bg-(--color-surface-container-low)/90 p-1 rounded-xl border border-border-muted/80 w-fit mb-4 shrink-0">
      <button 
        onClick={() => setCurrentVault('dev')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${
          currentVault === 'dev' ? 'bg-[#1a1a2e] text-blue-100 ring-1 ring-blue-500/50 shadow-[0_0_12px_rgba(59,130,246,0.3)]' : 'text-text-muted hover:text-white hover:bg-surface-container'
        }`}
      >
        <Terminal className={`w-4 h-4 ${currentVault === 'dev' ? 'text-dev-blue' : ''}`} />
        <span className="font-medium">Code</span>
        <span className={`text-[10px] px-1.5 py-0.5 rounded border ${currentVault === 'dev' ? 'bg-blue-500/10 text-blue-300 border-blue-500/20' : 'bg-surface text-text-hint border-border-muted'}`}>142</span>
      </button>
      <button 
        onClick={() => setCurrentVault('ai')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${
          currentVault === 'ai' ? 'bg-[#211633] text-purple-100 ring-1 ring-purple-500/50 shadow-[0_0_12px_rgba(168,85,247,0.3)]' : 'text-text-muted hover:text-white hover:bg-surface-container'
        }`}
      >
        <Sparkles className={`w-4 h-4 ${currentVault === 'ai' ? 'text-ai-purple' : ''}`} />
        <span className="font-medium">AI</span>
        <span className={`text-[10px] px-1.5 py-0.5 rounded border ${currentVault === 'ai' ? 'bg-purple-500/10 text-purple-300 border-purple-500/20' : 'bg-surface text-text-hint border-border-muted'}`}>38</span>
      </button>
      <button 
        onClick={() => setCurrentVault('links')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${
          currentVault === 'links' ? 'bg-[#0f2b23] text-emerald-100 ring-1 ring-emerald-500/50 shadow-[0_0_12px_rgba(52,211,153,0.3)]' : 'text-text-muted hover:text-white hover:bg-surface-container'
        }`}
      >
        <LinkIcon className={`w-4 h-4 ${currentVault === 'links' ? 'text-links-emerald' : ''}`} />
        <span className="font-medium">Links</span>
        <span className={`text-[10px] px-1.5 py-0.5 rounded border ${currentVault === 'links' ? 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20' : 'bg-surface text-text-hint border-border-muted'}`}>89</span>
      </button>
      <button 
        onClick={() => setCurrentVault('tools')}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm transition-all duration-200 ${
          currentVault === 'tools' ? 'bg-[#33220f] text-amber-100 ring-1 ring-amber-500/50 shadow-[0_0_12px_rgba(251,191,36,0.3)]' : 'text-text-muted hover:text-white hover:bg-surface-container'
        }`}
      >
        <Wrench className={`w-4 h-4 ${currentVault === 'tools' ? 'text-tools-amber' : ''}`} />
        <span className="font-medium">Dev Tools</span>
        <span className={`text-[10px] px-1.5 py-0.5 rounded border ${currentVault === 'tools' ? 'bg-amber-500/10 text-amber-300 border-amber-500/20' : 'bg-surface text-text-hint border-border-muted'}`}>18</span>
      </button>
    </div>
  );
};

export default VaultSwitcher;
